import React from "react";

type Props = {
  id: "logo";
};
const HeaderSvgSelector: React.FC<Props> = ({ id }) => {
  switch (id) {
    case "logo":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="160"
          height="25"
          viewBox="0 0 160 25"
        >
          <g>
            <g>
              <g />
              <g>
                <g>
                  <g>
                    <g>
                      <path
                        fill="#333"
                        d="M78.023 12.5c0 6.881-5.686 12.5-12.651 12.5S52.72 19.381 52.72 12.5 58.407 0 65.372 0c6.965 0 12.651 5.619 12.651 12.5zm-3.003 0c0-5.24-4.345-9.533-9.648-9.533-5.304 0-9.649 4.293-9.649 9.533 0 5.24 4.345 9.533 9.649 9.533 5.303 0 9.648-4.293 9.648-9.533z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        fill="#333"
                        d="M12.652 22.033c-5.304 0-9.649-4.293-9.649-9.533 0-5.24 4.345-9.533 9.649-9.533 2.684 0 5.048 1.073 6.837 2.778l2.108-2.083A12.626 12.626 0 0 0 12.652 0C5.687 0 0 5.619 0 12.5S5.687 25 12.652 25c3.514 0 6.645-1.389 8.945-3.662l-2.108-2.083c-1.79 1.705-4.154 2.778-6.837 2.778z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        fill="#333"
                        d="M104.342 22.033c-5.304 0-9.649-4.293-9.649-9.533 0-5.24 4.345-9.533 9.649-9.533 2.684 0 5.048 1.073 6.837 2.778l2.108-2.083A12.626 12.626 0 0 0 104.342 0C97.377 0 91.69 5.619 91.69 12.5S97.377 25 104.342 25c3.514 0 6.645-1.389 8.945-3.662l-2.108-2.083a9.716 9.716 0 0 1-6.837 2.778z"
                      />
                    </g>
                  </g>
                  <g>
                    <path fill="#333" d="M30.093.69H27.09v23.674h3.003z" />
                  </g>
                  <g>
                    <path fill="#333" d="M86.393 8.08H83.39v16.288h3.003z" />
                  </g>
                  <g>
                    <path fill="#333" d="M47.793.69H44.79v23.674h3.003z" />
                  </g>
                  <g>
                    <path fill="#333" d="M46.33 10.98h-17.7v2.967h17.7z" />
                  </g>
                  <g>
                    <path fill="#333" d="M134.697 21.34H120.32v2.967h14.377z" />
                  </g>
                  <g>
                    <path fill="#333" d="M134.697.69H120.32v2.967h14.377z" />
                  </g>
                  <g>
                    <path fill="#333" d="M84.852 5.677L79.74.69h10.224z" />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      fill="#333"
                      d="M124.727 13c0 1.326-.894 2.147-2.108 2.147s-2.109-.758-2.109-2.147V9.97h.83v3.093c0 .884.576 1.326 1.279 1.326.702 0 1.278-.442 1.278-1.326V9.97h.83z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#333"
                      d="M127.28 15.09h.83v-5.05h-.83zm1.98-2.714l2.11-2.336h-1.023l-2.172 2.336 2.364 2.715h1.022z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#333"
                      d="M136.869 15.09l-1.47-1.957h-.958v1.958h-.831V10.04h1.853c1.022 0 1.725.631 1.725 1.578 0 .695-.383 1.2-.958 1.452l1.533 2.084h-.894zm-2.364-2.714h1.022c.575 0 .895-.316.895-.82 0-.506-.32-.822-.895-.822h-1.022z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#333"
                      d="M142.938 14.203h-2.3l-.383.82h-.895l2.236-5.113h.256l2.236 5.114h-.894zm-1.15-2.778l-.83 2.083h1.725z"
                    />
                  </g>
                  <g>
                    <path fill="#333" d="M147.16 15.09h-.83v-5.05h.83z" />
                  </g>
                  <g>
                    <path
                      fill="#333"
                      d="M153.927 10.036v5.114h-.255l-3.131-3.535v3.409h-.831V9.91h.256l3.13 3.472V9.973h.831z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#333"
                      d="M159.937 10.734h-2.556v1.326h1.917v.695h-1.917v1.578H160v.758h-3.451V10.04h3.387z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    default:
      return <svg></svg>;
  }
};

export default HeaderSvgSelector;
